<script>
    export default {
        name: 'TagsList',
        props: {
            data: {
                type: Array,
                default: () => []
            }
        },
        render() {
            let data = this.data
            return (<div class="tagsList">
                {
                    data.map((item, index) => {
                        return (
                            <p key={index} class="tags">{item}</p>
                        )
                    })
                }
            </div>)
        }
    }
</script>
<style lang="less" scoped>
    .tagsList {
        position: absolute;
        top: 6px;
        left: 0px;
        right: 6px;
        display: flex;
        flex-wrap: wrap;
        p{
            padding: 2px 8px;
            background-color: #FF7000;
            color: #fff;
            flex-shrink: 0;
            font-size: 12px;
            border-radius: 3px;
            line-height: normal;
            margin-left: 6px;
        }
    }
</style>